import { render } from "./TokenAuth.vue?vue&type=template&id=581ae3fe&scoped=true"
import script from "./TokenAuth.vue?vue&type=script&lang=js"
export * from "./TokenAuth.vue?vue&type=script&lang=js"

import "./TokenAuth.vue?vue&type=style&index=0&id=581ae3fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581ae3fe"]])

export default __exports__